import React from "react";
import { Button } from "@design-system/Button/Button";
import { CollapseIcon, ExpandIcon } from "@icons";

interface Props {
    isCollapsed: boolean;
    onExpandAll: () => void;
    onCollapseAll: () => void;
}

/**
 * Expand/collapse-all toggle for SpreadsheetGrid-based report task bodies.
 * Mirrors the accounting tab's CollapseAllButton, which is bound to
 * ViewTable's imperative handle and therefore can't be reused here.
 */
export const ExpandCollapseAllButton: React.FC<Props> = ({
    isCollapsed,
    onExpandAll,
    onCollapseAll,
}) => (
    <Button
        iconOnly
        variant="primary"
        size="md"
        onClick={isCollapsed ? onExpandAll : onCollapseAll}
        aria-label={isCollapsed ? "Expand all" : "Collapse all"}
    >
        {isCollapsed ? <ExpandIcon /> : <CollapseIcon />}
    </Button>
);
